export const REPLACEMENT = 'Replacement';
export const LIFO = 'LIFO Adjustment';
export const RECLASS = 'Reclassification';

export const RECLASS_ADJUSTEMENT_TYPES = [
  { displayText: REPLACEMENT, id: 1 },
  { displayText: LIFO, id: 2 },
  { displayText: RECLASS, id: 3 },
];

export const LIFO_ADJ_TYPE = {
  LR: 'LR' /* * Lifo Reserve */,
  LA: 'LA' /* * Lifo Adjustment  = YYYY LIFO Adjustment = YYYY LIFO Reserve – ((YYYY-1) LIFO Reserve) */,
  LAN: 'LAN' /* * Lifo Adjustment Negative = (YYYY LIFO Adjustment = YYYY LIFO Reserve – ((YYYY-1) LIFO Reserve)) * -1 */,
};

export const AUTO_CALC_FIELDS = {
  incomeStatement: {
    grossProfit: 3 /* formula: 'Operating Revenue- COGS'*/,
    sga: 4,
    operatingRevenue: 1,
    cogs: 2,
    operatingIncome: 8 /* formula: 'Gross Profit-SGA' */,
  },
  yearEndBalance: {
    totalCurrentAssets: 25 /* formula: 'Cash Equivalents+Total Accounts Receivables+Total Inventories+Other Current Assets'*/,
    cashEquivalents: 18,
    totalAccountsReceivables: 20,
    totalInventories: 22,
    otherCurrentAssets: 24,
    totalAssets: 31 /* 'Total Current Assets+Net Property+Investments + Intangibes + Deferred Assets+Other Assets' */,
    netProperty: 26,
    investments: 27,
    intangibes: 28,
    deferredAssets: 29,
    otherAssets: 30,
  },
  liabilities: {
    totalCurrentLiabilities: 42 /* formula: 'Account Payable+Current Interest+Current Other Non Interest'*/,
    accountPayable: 41,
    currentInterest: 32,
    currentOtherNonInterest: 33,
    totalLiabilities: 46 /* 'Total Current Liabilities+Total Long-Term Debt+Deferred Liabilities+Other Liabilities' */,
    totalLongTermDebt: 43,
    deferredLiabilities: 44,
    otherLiabilities: 45,
    totalLiabilitiesAndStockholdersEquity: 48 /* 'Toatl Liabilities+Total StockHoders Equity' */,
    totalStockHodersEquity: 47,
  },
};

export const LIFO_ADJ_FIELDS = [
  { label: 'cogs', mappingId: AUTO_CALC_FIELDS.incomeStatement.cogs, lifoType: LIFO_ADJ_TYPE.LAN },
  { label: 'grossProfit', mappingId: AUTO_CALC_FIELDS.incomeStatement.grossProfit, lifoType: LIFO_ADJ_TYPE.LA },
  { label: 'opIncome', mappingId: AUTO_CALC_FIELDS.incomeStatement.operatingIncome, lifoType: LIFO_ADJ_TYPE.LA },
  { label: 'preTaxIncome', mappingId: 13, lifoType: LIFO_ADJ_TYPE.LA },
  { label: 'netIncome', mappingId: 17, lifoType: LIFO_ADJ_TYPE.LA },
  { label: 'totalInven', mappingId: AUTO_CALC_FIELDS.yearEndBalance.totalInventories, lifoType: LIFO_ADJ_TYPE.LR },
  { label: 'totalCurAssets', mappingId: AUTO_CALC_FIELDS.yearEndBalance.totalCurrentAssets, lifoType: LIFO_ADJ_TYPE.LR },
  { label: 'totalAssets', mappingId: AUTO_CALC_FIELDS.yearEndBalance.totalAssets, lifoType: LIFO_ADJ_TYPE.LR },
  { label: 'totalStockholderEquity', mappingId: AUTO_CALC_FIELDS.liabilities.totalStockHodersEquity, lifoType: LIFO_ADJ_TYPE.LR },
  {
    label: 'totalLiabilitiesPlusStockholderEquity',
    mappingId: AUTO_CALC_FIELDS.liabilities.totalLiabilitiesAndStockholdersEquity,
    lifoType: LIFO_ADJ_TYPE.LR,
  },
];

export const YEAR_END_BALANCE_SHEET_ASSETS_TAB_NAME = 'Year End Balance Sheet Assets';
export const AVG_BALANCE_SHEET_ASSETS_TAB_NAME = 'Average Balance Sheet Assets';
export const READ_ONLY_HEADER_COLUMNS_MAPPING_ID = [55 /* ComparableFYEnd: */, 56 /* FYMonths: */, 57 /* ExchangeRate: */];

export const READ_ONLY_FIELDS = [
  AUTO_CALC_FIELDS.incomeStatement.grossProfit,
  AUTO_CALC_FIELDS.incomeStatement.operatingIncome,
  AUTO_CALC_FIELDS.yearEndBalance.totalCurrentAssets,
  AUTO_CALC_FIELDS.yearEndBalance.totalAssets,
  AUTO_CALC_FIELDS.liabilities.totalCurrentLiabilities,
  AUTO_CALC_FIELDS.liabilities.totalLiabilities,
  AUTO_CALC_FIELDS.liabilities.totalLiabilitiesAndStockholdersEquity,
  50 /*"Financial Statement Audit Opinion" */,
  54 /*"Reason for Restatement of Financial Data"*/,
  49 /*"Depreciation/Amortization Expense Source"*/,
];

export const VAL_MSG_NOT_ALLOWED_COMBINATION = 'Selected combination not allowed. Allowed Combination:  Reclass and LIFO';
